module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-registration"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.formSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Client")]), _c('SearchEntity', {
    staticClass: "mb-1",
    attrs: {
      "entity": "clients"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(result) {
        return [_c('div', {
          staticClass: "quick-search-result"
        }, [_c('div', [_c('small', [_vm._v("CL" + _vm._s(result.result.id))]), _c('div', [_vm._v(_vm._s(result.result.name) + " " + _vm._s(result.result.surname))]), (result.result.organization_name) ? _c('div', [_c('small', [_vm._v(_vm._s(result.result.organization_name))])]) : _vm._e(), _c('div', [_c('small', [_vm._v(_vm._s(result.result.phone))])])])])]
      }
    }]),
    model: {
      value: (_vm.body.client_id),
      callback: function($$v) {
        _vm.$set(_vm.body, "client_id", $$v)
      },
      expression: "body.client_id"
    }
  })], 1), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Name  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required',
      "required": "required"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Surname  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required',
      "required": "required"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.surname),
      expression: "body.surname"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "surname", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Title"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.title),
      expression: "body.title"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr")]), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs")]), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms")]), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")])])])]), _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Gender"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.gender),
      expression: "body.gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-"
    }
  }, [_vm._v("-")]), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("M")]), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("F")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("Mobile  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.mobile_phone),
      expression: "body.mobile_phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "international prefix call (ex: +39-3951231231)",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.mobile_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "mobile_phone", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Email  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.email),
      expression: "body.email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "email", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Birthdate  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('date-picker', {
    attrs: {
      "required": "required"
    },
    model: {
      value: (_vm.body.birthdate),
      callback: function($$v) {
        _vm.$set(_vm.body, "birthdate", $$v)
      },
      expression: "body.birthdate"
    }
  })], 1)])]), _vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Street name  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.street),
      expression: "body.address.street"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "required"
    },
    domProps: {
      "value": (_vm.body.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "street", $event.target.value)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('label', [_vm._v("City  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required',
      "required": "required"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.city),
      expression: "body.address.city"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "city", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Region  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required',
      "required": "required"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.region),
      expression: "body.address.region"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.address.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "region", $event.target.value)
      }
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-3 columns"
  }, [_c('label', [_vm._v("Country  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('selectize-country', {
    on: {
      "optionSelected": _vm.selectCountry
    }
  })], 1)]), _c('div', {
    staticClass: "small-12 large-2 columns"
  }, [_c('label', [_vm._v("Postal code  "), _c('tooltip', {
    attrs: {
      "open": true,
      "position": 'right',
      "tip": 'Field Required'
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.address.postal_code),
      expression: "body.address.postal_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.body.address.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body.address, "postal_code", $event.target.value)
      }
    }
  })], 1)])]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _c('div', {
    staticClass: "small-12 large-4 columns"
  }, [_c('div', {
    staticClass: "switch large"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document),
      expression: "document"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "add-document",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.document) ? _vm._i(_vm.document, null) > -1 : (_vm.document)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.document,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.document = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.document = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.document = $$c
        }
      }
    }
  }), _vm._m(2)])])]), (_vm.document) ? _c('backoffice-driver-license-create', {
    on: {
      "driverLicenseUpdated": _vm.setDriverLicenseFields
    }
  }) : _vm._e(), _vm._m(3)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Residential address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-12 large-4 large-offset-3 columns"
  }, [_c('label', [_vm._v("Add document?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-paddle",
    attrs: {
      "for": "add-document"
    }
  }, [_c('span', {
    staticClass: "switch-active",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Yes")]), _c('span', {
    staticClass: "switch-inactive",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-center"
  }, [_c('label', [_c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df5d825e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateDriver.vue
// module id = 2513
// module chunks = 1